import { atom } from 'recoil';

import { THEME_TYPE } from './theme.model';

export const selectedThemeState = atom<THEME_TYPE>({
  key: 'selectedThemeState',
  default: (localStorage.getItem('theme') as THEME_TYPE) || THEME_TYPE.LIGHT,
});
